import type { ParamsGetMerchflowsReviews } from "@CommonApi/merchflows/reviews";
import { ReviewStatus } from "@CommonTypes/merchflow/ReviewStatus";
import { normalizeMultiValue } from "src/merchflows/shared/multiValue";

export { repeatedBareArrayParamsSerializer } from "src/api/queryParams";

const reviewStatusValues = new Set<string>(Object.values(ReviewStatus));

const isReviewStatus = (value: string): value is ReviewStatus => reviewStatusValues.has(value);

const isReviewStatusArray = (values: string[]): values is ReviewStatus[] =>
  values.length > 0 && values.every(isReviewStatus);

export const normalizeMerchflowsReviewsQueryParams = (
  queryParams?: ParamsGetMerchflowsReviews,
): ParamsGetMerchflowsReviews | undefined => {
  if (!queryParams) {
    return undefined;
  }

  const normalizedStatus = normalizeMultiValue(queryParams.status) || [];

  return {
    ...queryParams,
    status: isReviewStatusArray(normalizedStatus) ? normalizedStatus : undefined,
    category: normalizeMultiValue(queryParams.category),
    subcategory: normalizeMultiValue(queryParams.subcategory),
  };
};
